const buttonPopup = () => {
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('[data-popup-button]').forEach((popupButton) => {
            popupButton.addEventListener("click", (event) => {
                event.preventDefault();
                const popupElement = popupButton.closest('[data-popup]');
                const body = document.querySelector('body');
                if(popupElement && body) {
                    popupElement.classList.toggle('button-popup--open');
                    body.style.pointerEvents = 'none';
                }
            });
        });
        document.querySelectorAll('[data-popup-close]').forEach((popupCloseButton) => {
            popupCloseButton.addEventListener("click", (event) => {
                event.preventDefault();
                const popupElement = popupCloseButton.closest('[data-popup]');
                const body = document.querySelector('body');
                if(popupElement && body) {
                    popupElement.classList.toggle('button-popup--open');
                    body.style.pointerEvents = 'all';
                }
            });
        });
    });
}

export { buttonPopup }